import { combineReducers } from 'redux';
import { LocalHydrationReducer, PodcastStateReducer, } from '@amzn/dm-podcast-web-player';
import { AppEventsReducer } from './AppEventsReducer';
import { AuthenticationReducer } from './AuthenticationReducer';
import { BannerReducer } from './BannerReducer';
import { BrowserReducer } from './BrowserReducer';
import { ContentViewedInfoReducer } from './ContentViewedInfoReducer';
import { ContextMenuReducer } from './ContextMenuReducer';
import { DialogReducer } from './DialogReducer';
import { InteractionReducer } from './InteractionReducer';
import { LyricsViewedReducer } from './LyricsViewedReducer';
import { PlaylistRecommendationsReducer, } from './PlaylistRecommendationsReducer';
import { MediaReducer } from './MediaReducer';
import { PlaybackActionsReducer } from './PlaybackActionsReducer';
import { PlaybackEventsReducer } from './PlaybackEventsReducer';
import { PlaybackStatesReducer } from './PlaybackStatesReducer';
import { PreviousPlaybackStateReducer, } from './PreviousPlaybackStateReducer';
import { PlaybackPerformanceReducer, } from './PlaybackPerformanceReducer';
import { RibbonReducer } from './RibbonReducer';
import { ScrubInfoReducer } from './ScrubInfoReducer';
import { SearchSuggestionsReducer } from './SearchSuggestionsReducer';
import { SettingReducer } from './SettingReducer';
import { SkyfireMethodQueueReducer } from './SkyfireMethodQueueReducer';
import { SoftRefreshReducer } from './SoftRefreshReducer';
import { StorageReducer } from './StorageReducer';
import { TemplateStackReducer } from './TemplateStackReducer';
import { TerminationTimestampReducer, } from './TerminationTimestampReducer';
import { ToastReducer } from './ToastReducer';
import { TooltipReducer } from './TooltipReducer';
import { TransportOverlayReducer } from './TransportOverlayReducer';
import { ActivityFeedReducer } from './ActivityFeedReducer';
import { VideoNPVStateReducer } from './VideoNPVStateReducer';
import { SampleMediaReducer } from './SampleMediaReducer';
import { SamplePlaybackEventsReducer } from './SamplePlaybackEventsReducer';
import { SamplePlaybackStatesReducer } from './SamplePlaybackStatesReducer';
import { RWPReducer } from './RWPReducer';
import { PlaybackDurationStateReducer, } from './PlaybackDurationStateReducer';
import { ContainerAppRenderReducer } from './ContainerAppRenderReducer';
import { TabsReducer } from './TabsReducer';
export const RootReducer = combineReducers({
    AppEvents: AppEventsReducer,
    Authentication: AuthenticationReducer,
    Dialog: DialogReducer,
    ContextMenu: ContextMenuReducer,
    Media: MediaReducer,
    SampleMedia: SampleMediaReducer,
    InteractionState: InteractionReducer,
    PlaybackActions: PlaybackActionsReducer,
    PlaybackEvents: PlaybackEventsReducer,
    SamplePlaybackEvents: SamplePlaybackEventsReducer,
    PlaybackStates: PlaybackStatesReducer,
    SamplePlaybackStates: SamplePlaybackStatesReducer,
    PlaybackPerformance: PlaybackPerformanceReducer,
    SkyfireMethodQueue: SkyfireMethodQueueReducer,
    Storage: StorageReducer,
    TemplateStack: TemplateStackReducer,
    SearchSuggestions: SearchSuggestionsReducer,
    LyricsViewed: LyricsViewedReducer,
    BrowserState: BrowserReducer,
    Banner: BannerReducer,
    Ribbon: RibbonReducer,
    Toast: ToastReducer,
    Tooltip: TooltipReducer,
    ScrubInfo: ScrubInfoReducer,
    SoftRefresh: SoftRefreshReducer,
    TransportOverlay: TransportOverlayReducer,
    LocalHydrationState: LocalHydrationReducer,
    PodcastState: PodcastStateReducer,
    PreviousPlaybackState: PreviousPlaybackStateReducer,
    TerminationTimestamp: TerminationTimestampReducer,
    ActivityFeed: ActivityFeedReducer,
    VideoNPVState: VideoNPVStateReducer,
    ContentViewedInfo: ContentViewedInfoReducer,
    PlaylistRecommendations: PlaylistRecommendationsReducer,
    Setting: SettingReducer,
    RWP: RWPReducer,
    PlaybackDurationState: PlaybackDurationStateReducer,
    ContainerAppRender: ContainerAppRenderReducer,
    Tabs: TabsReducer,
});
